import { isFailed } from 'conversations-async-data/async-data/operators/statusComparators';

// TODO: move to composer-data

// TODO: move to composer-data
import invariant from 'conversations-thread-data/utils/invariant';
export const accountsFailed = ({
  asyncConnectedAccounts
}) => {
  invariant(Boolean(asyncConnectedAccounts), 'asyncConnectedAccounts is required for accountsFailed disabling strategy');
  return isFailed(asyncConnectedAccounts) ? {
    disabled: true,
    sendDisabledReason: 'ACCOUNTS_FAILED_TO_LOAD'
  } : null;
};